import httpClient from "@/http-client";

export const get = (Options = {}) => {
    return httpClient
        .get("/api/sangkat-communes", Options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const store = data => {
    return httpClient
        .post("/api/sangkat-communes", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const update = (id, data) => {
    return httpClient
        .put(`/api/sangkat-communes/${id}`, data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const destroy = id => {
    return httpClient
        .delete(`/api/sangkat-communes/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const cityProvince = data => {
    return httpClient
        .get("/api/sangkat-communes/city-provinces", data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export const khanDistrict = data => {
    return httpClient
        .get("/api/sangkat-communes/khan-districts", { params: data })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data));
};

export default { get, store, update, destroy, cityProvince, khanDistrict };
